"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GROUPED_TIMEZONES = exports.createTimezoneObject = void 0;
const tslib_1 = require("tslib");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
const timezones_whitelist_1 = require("./timezones-whitelist");
function getFormattedTimezonesList() {
    const timezoneGroupsMap = new Map();
    timezones_whitelist_1.TIMEZONES_WHITELIST.map(tzName => {
        const offsetGMT = moment_timezone_1.default.tz(tzName).format("Z");
        const formattedName = tzName.replace("_", " ");
        const timezone = {
            name: tzName,
            formattedGMT: `(GMT ${offsetGMT}) ${formattedName}`
        };
        const group = timezoneGroupsMap.get(offsetGMT);
        if (group) {
            group.timezones.push(timezone);
        }
        else {
            timezoneGroupsMap.set(offsetGMT, {
                offsetGMT,
                timezones: [timezone]
            });
        }
    });
    return Array.from(timezoneGroupsMap.values());
}
function createTimezoneObject(tzName) {
    const offsetGMT = moment_timezone_1.default.tz(tzName).format("Z");
    const formattedName = tzName.replace("_", " ");
    const timezone = {
        name: tzName,
        formattedGMT: `(GMT ${offsetGMT}) ${formattedName}`
    };
    return timezone;
}
exports.createTimezoneObject = createTimezoneObject;
exports.GROUPED_TIMEZONES = getFormattedTimezonesList();
//# sourceMappingURL=timezones.js.map